import React, { memo, useEffect, useRef } from 'react';
import Svg, { Circle } from 'react-native-svg';
import { useAnimatedProps, useSharedValue, withDelay, withTiming, } from 'react-native-reanimated';
import { StyleSheet, View } from 'react-native';
import { AnimatedCircle } from './AnimatedComponents';
const CircularProgress = ({ size, large, percent, children, progressCircleColor, backgroundCircleColor, }) => {
    const hasMounted = useRef(false);
    const percentSharedValue = useSharedValue(percent);
    const r = size / 2;
    const bgCircleStroke = large ? 12 : 6;
    const progressBarStroke = large ? 16 : 8;
    const progressBarR = progressBarStroke / 2;
    const circumference = 2 * Math.PI * (r - progressBarR);
    const animatedProps = useAnimatedProps(() => ({
        strokeDashoffset: circumference * (1 - percentSharedValue.value / 100),
    }));
    useEffect(() => {
        if (hasMounted.current) {
            percentSharedValue.value = withDelay(200, withTiming(percent));
        }
        else {
            hasMounted.current = true;
        }
    }, [percent]);
    return (<View>
      <Svg viewBox={`0 0 ${size} ${size}`} width={2 * r} height={2 * r}>
        <Circle cx={r} cy={r} fill="transparent" r={r - progressBarR} strokeWidth={bgCircleStroke} stroke={backgroundCircleColor}/>
        <AnimatedCircle cx={r} cy={r} fill="transparent" r={r - progressBarR} strokeLinecap="round" stroke={progressCircleColor} animatedProps={animatedProps} strokeWidth={progressBarStroke} strokeDasharray={circumference}/>
      </Svg>
      <View style={styles.childrenContainer}>{children}</View>
    </View>);
};
const styles = StyleSheet.create({
    childrenContainer: {
        ...StyleSheet.absoluteFillObject,
        alignItems: 'center',
        justifyContent: 'center',
    },
});
export default memo(CircularProgress);
